// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewer-button{width:50px;height:50px;right:32px;top:32px;background-color:#000}.viewer-button:hover{background-color:hsla(0,0%,80%,.5)!important}", ""]);
// Exports
module.exports = exports;
